'use strict';

const Mn = require('backbone.marionette');

/**
 * Popover に別の View を内包できるようにする
 */
module.exports = Mn.View.extend({
    template: false,
    regions: {
        content: '.popover-content'
    },
    maxHeight: 512,

    initialize: function(options) {
        _.bindAll(this, 'showContent', '_click');
        this._view = options.view;
        this._placement = options.placement;
        this._width = options.width;
        this._show = options.show;
        this.$el.css('visibility', 'hidden');
        this._shown = false;
        this._visible = false;
    },

    onDomRefresh: function() {
        this.$el.popover({
            content: $(`<div style="width: ${this._width}px; height: 20px;">aaaa</div>`),
            html: true,
            trigger: 'manual',
            placement: this._placement,
            container: this.$el
        });
        this.$el.popover('show');
        this.$el.on('shown.bs.popover', this.showContent);

        return this;
    },

    toggle: function () {
        if(!this._visible) {
            return;
        }
        if(this._shown) {
            this.hide();
        } else {
            this.show();
        }
    },

    show: function() {
        this.$el.css('visibility', 'visible');
        this._shown = true;
        setTimeout(_.bind(function() {
            $('body').on('click', this._click);
        }, this), 1);

        this.trigger('show');
    },

    _click: function(e) {
        // popover の配下のコンテンツがクリックされた
        if(e && this.$(e.target).length > 0) {
            this.trigger('click');
        } else {
            this.hide();
        }
    },

    hide: function(e) {
        this.$el.css('visibility', 'hidden');
        this._shown = false;
        $('body').off('click', this._click);

        this.trigger('hide');
    },

    showContent: function() {
        this.showChildView('content', this._view);
        this.$('.popover-content').css('max-height', this.getOption('maxHeight'));
        this.$('.popover-content').addClass('popover-content-no-padding');
        if(this._width) {
            this.$('.popover').css('max-width', this._width);
        }
        this._visible = true;
        if(this._show) {
            this.show();
        }
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/popover.js